import { render, staticRenderFns } from "./gj-supplier-select.vue?vue&type=template&id=21997d17&scoped=true&"
import script from "./gj-supplier-select.vue?vue&type=script&lang=js&"
export * from "./gj-supplier-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21997d17",
  null
  
)

export default component.exports